import { Controller } from "@hotwired/stimulus"

// Plays a Wistia video inside a shared Bootstrap modal, sized to the video's
// own aspect ratio. Each thumbnail trigger opens the modal via data-bs-toggle
// and carries data-wistia-id / -title (BS passes the clicked trigger as
// event.relatedTarget). We don't hardcode portrait vs landscape per clip — on
// open we ask Wistia's oEmbed endpoint for the real dimensions and shape the
// box to match (landscape fills the wide dialog; a portrait clip is capped by
// height so it doesn't overflow). Falls back to 16:9 if the lookup fails. The
// iframe is torn down on hide so playback stops.
export default class extends Controller {
  static targets = ["frame", "title", "dialog"]

  open(event) {
    const trigger = event.relatedTarget
    if (!trigger) return

    const id = trigger.dataset.wistiaId
    this.titleTarget.textContent = trigger.dataset.wistiaTitle || "Video"
    this.applyAspect(16, 9) // sensible default until oEmbed responds
    this.frameTarget.innerHTML =
      `<iframe src="https://fast.wistia.net/embed/iframe/${id}?seo=false&autoPlay=true" ` +
      `allow="autoplay; fullscreen" allowfullscreen style="border:0;"></iframe>`
    this.sizeToVideo(id)
  }

  close() {
    this.frameTarget.innerHTML = ""
  }

  async sizeToVideo(id) {
    try {
      const media = `https://csepub.wistia.com/medias/${id}`
      const res = await fetch(`https://fast.wistia.com/oembed.json?url=${encodeURIComponent(media)}`)
      if (!res.ok) return
      const { width, height } = await res.json()
      if (width && height) this.applyAspect(width, height)
    } catch (_e) {
      // keep the 16:9 default
    }
  }

  applyAspect(width, height) {
    const landscape = width >= height
    this.frameTarget.style.setProperty("--bs-aspect-ratio", `${(height / width) * 100}%`)
    // Landscape fills the wide dialog; portrait is bounded by viewport height so
    // a tall clip doesn't run off-screen, and mx-auto keeps it centered.
    this.frameTarget.style.width = landscape ? "100%" : `min(100%, calc(70vh * ${width / height}))`
    this.dialogTarget.classList.toggle("modal-lg", landscape)
  }
}
